import { enviroments } from '@infrastructure/enviroments';
import { Segments } from '@models';
import { base } from '@service/base';

const BANNER_MS_BASE_URL = enviroments.BASE_URL;

export async function getSegmentById(
  id: number
): Promise<Segments.SegmentsDto> {
  const { data } = await base({
    baseURL: BANNER_MS_BASE_URL,
    url: `/segments/${id}`,
    method: 'GET',
  });

  if (!data) {
    throw Error(data.message);
  }

  return data;
}
